import React, { useState } from 'react';
import './App.css';

const content = {
    'demo_request': {
        'title': "Reservar Demostración",
        'subtitle': 'Programe sin cargo su reunión con uno de nuestros consultores, usted obtendrá:',
        'list': ['Una demostración Online de las aplicaciones que desee.',
            'Acceso exclusivo a una prueba gratuita durante 30 días.',
            'Asistencia durante su período de prueba a través de nuestro canal de soporte.'
        ]
    },
    'free_trial_request': {
        'title': "Iniciar Prueba Gratuita",
        'subtitle':'Durante el período de prueba, usted podrá acceder sin costo a todas las funcionalidades seleccionadas.',
        'list': [
            'Complete el formulario a su derecha para programar una reunión 1 a 1 con nosotros. Le daremos acceso a su instancia de prueba y lo ayudaremos a sacar el máximo provecho de la misma.',
            'Durante todo su mes de prueba, tendrá acceso a nuestro centro de asistencia, donde resolveremos cualquier inquietud o problema surgido durante su período de prueba'
        ]
    }
}


function FormExplanation(props) {

    return (

        <div className="text-left p-2 fade-fast">
            <h4>{content[props.form_type].title}</h4>
            <h6>{content[props.form_type].subtitle}</h6>
            <ul className="check-ul">
                {content[props.form_type].list.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>

        </div>

    );
}

export default FormExplanation;
